module.exports = __webpack_public_path__ + "static/media/yfi.702e3634.png";